import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {HttpService} from "../../../../../core";
import {ProjectService} from "../../../../../core/services/project.service";
import {UserService} from "../../../../../core/services/user.service";
import {FileSystemFileEntry, NgxFileDropEntry} from "ngx-file-drop";
import {SuccessDialogComponent} from "./success-dialog/success-dialog.component";
import {environment} from "../../../../../../environments/environment";


@Component({
    selector: 'add-eoi',
    templateUrl: './add-eoi.html',
    styleUrls: ['./add-eoi.scss']
})
export class AddEoi implements OnInit {
    SERVER_URL = environment.SERVER_URL;
    lang: any = 'en';


    @Input() projectId: number;
    @Input() project: any;
    @Output() closeAdd = new EventEmitter();

    fileName: any;

    singleFileSizeLimit = 41943040; // 40M
    totalFileSizeLimit = 94371840; // 90M

    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    mobile: string;
    addressLine: string;
    state: string;
    country: string;
    postcode: string;

    contractFiles: any = [];
    invalidFileType: boolean = false;
    contractRecieptFiles: any = [];
    invalidFileRecieptType: boolean = false;

    isRequired: boolean = false;
    isSubmit: boolean = false;

    tiles = [
        {text: 'One', cols: 3, rows: 1, color: 'lightblue'},
        {text: 'Two', cols: 1, rows: 2, color: 'lightgreen'},
        {text: 'Three', cols: 1, rows: 1, color: 'lightpink'},
        {text: 'Four', cols: 2, rows: 1, color: '#DDBDF1'},
    ];

    currentTime: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private dialog: MatDialog,
                private httpService: HttpService,
                private projectService: ProjectService,
                private userService: UserService) {
        this.currentTime = new Date();
    }


    ngOnInit() {
        // 获取EOI模板
        this.httpService.getEoiForm(this.projectId).subscribe((res: any) => {
            this.fileName = res.data ? res.data.fileName : null
        })
    }

    back(isRefresh) {
        this.closeAdd.emit(isRefresh);
    }

    dropped(files: any) {
        const fileLength = this.contractFiles.length
        const totalLength = fileLength + files.length
        if (totalLength > 3) {
            this.invalidFileType = true;
            return;
        }
        this.invalidFileType = false;
        for (const droppedFile of files) {
            const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
            const reader = new FileReader()
            fileEntry.file((file: any) => {
                file.progress = 0;
                if (file.size < this.singleFileSizeLimit) {
                    this.contractFiles.push(file);
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        console.log("文件数据：" + reader.result)
                    }
                } else {
                    this.invalidFileType = true;
                }
                console.log(this.contractFiles);
            });
            if (this.contractFiles.length > 3) {
                this.invalidFileType = true;
            }
            if (this.invalidFileType) {
                break
            }
        }

        this.uploadFilesSimulatorSync()
    }

    uploadFilesSimulatorSync() {

        this.contractFiles.forEach(item => {
            const progressInterval = setInterval(() => {
                if (item.progress === 100) {
                    clearInterval(progressInterval);
                } else {
                    item.progress += 5;
                }
            }, 200);
        })
    }

    removeFile(f) {
        this.contractFiles = this.contractFiles.filter(file => {
            return file.name !== f.name;
        });
    }

    fileOver(e) {

    }

    fileLeave(e) {

    }

    droppedReciept(files: any) {
        const fileLength = this.contractRecieptFiles.length
        const totalLength = fileLength + files.length
        if (totalLength > 3) {
            this.invalidFileRecieptType = true;
            return;
        }
        this.invalidFileRecieptType = false;
        for (const droppedFile of files) {
            const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
            const reader = new FileReader()
            fileEntry.file((file: any) => {
                file.progress = 0;
                if (file.size < this.singleFileSizeLimit) {
                    this.contractRecieptFiles.push(file);
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        console.log("文件数据：" + reader.result)
                    }
                } else {
                    this.invalidFileRecieptType = true;
                }
                console.log(this.contractRecieptFiles);
            });
            if (this.contractFiles.length > 3) {
                this.invalidFileRecieptType = true;
            }
            if (this.invalidFileRecieptType) {
                break
            }
        }

        this.uploadFilesSimulatorSyncReciept()
    }

    uploadFilesSimulatorSyncReciept() {
        this.contractRecieptFiles.forEach(item => {
            const progressInterval = setInterval(() => {
                if (item.progress === 100) {
                    clearInterval(progressInterval);
                } else {
                    item.progress += 5;
                }
            }, 200);
        })
    }

    removeRecieptFile(f) {
        this.contractRecieptFiles = this.contractRecieptFiles.filter(file => {
            return file.name !== f.name;
        });
    }

    fileOverReciept(e) {
    }

    fileLeaveReciept(e) {
    }

    submit() {
        this.check();
        if (this.isSubmit && !this.isRequired) {
            this.userService.currentUser.toPromise().then((res: any) => {
                const fd = new FormData();
                fd.append("firstName", this.firstName)
                fd.append("middleName", this.middleName)
                fd.append("lastName", this.lastName)
                fd.append("email", this.email)
                fd.append("phoneNumber", this.mobile)
                fd.append("addressLine1", this.addressLine)
                fd.append("state", this.state)
                fd.append("country", this.country)
                fd.append("postCode", this.postcode)
                this.contractFiles.forEach(file => {
                    fd.append('eoiFormFile', file);
                });
                this.contractRecieptFiles.forEach(file => {
                    fd.append('receipt', file);
                });
                this.httpService.addEoi(this.projectId, fd).subscribe((res: any) => {
                    this.dialog.open(SuccessDialogComponent, {disableClose: true}).afterClosed().subscribe(result => {
                        this.back(true)
                    })
                })
            })
        } else {
            return;
        }
    }

    openForm() {
        window.open(this.SERVER_URL + 'files/' + this.project.projectCode + '/eoi_files/' + this.fileName);
    }

    check() {
        this.isSubmit = true;
        if (!this.firstName) {
            document.getElementById("first").style.borderColor = "red";
            this.isSubmit = false;
        } else {
            document.getElementById("first").style.borderColor = "";
        }
        // if (!this.middleName) {
        //     document.getElementById("middle").style.borderColor = "red";
        //     this.isSubmit = false;
        // } else {
        //     document.getElementById("middle").style.borderColor = "";
        // }
        if (!this.lastName) {
            document.getElementById("last").style.borderColor = "red";
            this.isSubmit = false;
        } else {
            document.getElementById("last").style.borderColor = "";
        }
        if (!this.email) {
            document.getElementById("email").style.borderColor = "red";
            this.isSubmit = false;
        } else {
            document.getElementById("email").style.borderColor = "";
        }
        if (!this.mobile) {
            document.getElementById("mobile").style.borderColor = "red";
            this.isSubmit = false;
        } else {
            document.getElementById("mobile").style.borderColor = "";
        }
        if (!this.addressLine) {
            document.getElementById("address").style.borderColor = "red";
            this.isSubmit = false;
        } else {
            document.getElementById("address").style.borderColor = "";
        }
        if (!this.state) {
            document.getElementById("state").style.borderColor = "red";
            this.isSubmit = false;
        } else {
            document.getElementById("state").style.borderColor = "";
        }
        if (!this.country) {
            document.getElementById("country").style.borderColor = "red";
            this.isSubmit = false;
        } else {
            document.getElementById("country").style.borderColor = "";
        }
        if (!this.postcode) {
            document.getElementById("postcode").style.borderColor = "red";
            this.isSubmit = false;
        } else {
            document.getElementById("postcode").style.borderColor = "";
        }
        if (this.contractFiles.length <= 0) {
            this.isRequired = true;
        } else {
            this.isRequired = false
        }
    }
}
